export default "__VITE_ASSET__CsitdW1u__"